import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { useEffect } from "react";
import { MultiSelect } from "primereact/multiselect";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Util, timesheetApi } from "../../services";
import { Card } from "primereact/card";
import { classNames } from "primereact/utils";
// import { Paginator } from "primereact/paginator";
// import CONF from "../../config/appProperties";

export default function DayWiseTimesheetReport() {
  const [dayWiseData, setDayWiseData] = useState([]);
  const [allocatedProjectData, setAllocatedProjectData] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [teamMember, setTeamMember] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [errorLog, SetErrorLog] = useState(false);
  const [isExportDisabled, setIsExportDisabled] = useState(true);

  // const [totalRecords, setTotalRecords] = useState(0);
  // const [contentFirst, setContentFirst] = useState(0);
  // const [page, setPage] = useState(0);
  // const [size, setSize] = useState(CONF.pageSize);
  // const [basicFirst, setBasicFirst] = useState(0);
  // const [basicRows, setBasicRows] = useState(10);
  // const [rowsPerPageOptions, setRowsPerPageOptions] = useState(CONF.rowsPerPageOptions);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchAllocatedProjectData();
      count++;
    }
  }, []);

  const fetchAllocatedProjectData = (param = {}) => {
    timesheetApi.getAllProjectByUser(param).then((resp) => {
      try {
        setAllocatedProjectData(resp.data.data);
      } catch (error) {
        // Error handle
      }
    });
  };

  const getProjectByUser = (e) => {
    setSelectedProject(e.value);
    var idList = [];
    e.value.map((item, key) => {
      idList[key] = item.id;
    });
    let param = {
      projectIds: idList,
    };
    timesheetApi.getUsersByProjectIdInDayWise(param).then((resp) => {
      try {
        var memberListing = [];
        resp.data.data.map((item) => {
          let objMember = {
            id: item.id,
            name:
              item.firstName.charAt(0).toUpperCase() +
              item.firstName.slice(1) +
              " " +
              item.lastName.charAt(0).toUpperCase() +
              item.lastName.slice(1),
          };
          memberListing.push(objMember);
        });
        setEmployeeList(memberListing);
      } catch (error) {
        // Error handle
      }
    });
  };

  const validateError = () => {
    if (
      selectedProject === null ||
      dateRange === undefined ||
      teamMember === null
    ) {
      SetErrorLog(true);
      return true;
    }
  };

  const filterDayWiseTimesheet = () => {
    // const filterDayWiseTimesheet = (param = {}) => {
    // if (param.pageNo === undefined) {
    //   setPage(0);
    //   setContentFirst(0);
    // }
    var memberList = [];
    teamMember?.map((item, key) => {
      memberList[key] = item?.id;
    });

    var projectList = [];
    selectedProject?.map((item, key) => {
      projectList[key] = item?.id;
    });

    const error = validateError();

    if (error) {
    } else {
      // param.fromDate = Util.dateConverter(dateRange[0]);
      // param.toDate = Util.dateConverter(dateRange[1]);
      // param.projectIds = projectList;
      // param.userIds = memberList;
      let param = {
        fromDate: Util.dateConverter(dateRange[0]),
        toDate: Util.dateConverter(dateRange[1]),
        projectIds: projectList,
        userIds: memberList,
      };
      timesheetApi.dayWiseTimesheetData(param).then((resp) => {
        try {
          setDayWiseData(resp.data.data);
          // setTotalRecords(576);
          if (resp?.data?.data?.length > 0) {
            setIsExportDisabled(false);
          }
        } catch (error) {
          // Error handle
        }
      });
    }
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(dayWiseData);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      Util.saveAsExcelFile(excelBuffer, "Day-Wise-Timesheet");
    });
  };

  const DayWiseFilter = (e) => {
    return (
      <React.Fragment>
        <div className="grid timesheet_filter_box">
          <div
            className="field col-12 md:col-1 mb-0 mt-3"
            style={{ fontWeight: "700" }}
          >
            Filter :
          </div>

          <div className="field col-6 md:col-3 mb-0">
            <MultiSelect
              filter
              value={selectedProject}
              options={allocatedProjectData}
              onChange={(e) => getProjectByUser(e)}
              optionLabel="title"
              placeholder="Select Project"
              maxSelectedLabels={1}
              showClear
              style={{ width: "158px" }}
              className={classNames(
                { "p-invalid": errorLog && !selectedProject },
                "mt-2",
              )}
            />
            {errorLog && (
              <span>
                {selectedProject === null && (
                  <div style={{ color: "red" }}>Select Project!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-6 md:col-3 mb-0">
            <Calendar
              id="range"
              value={dateRange}
              onChange={(e) => setDateRange(e.value)}
              selectionMode="range"
              readOnlyInput
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              showIcon
              placeholder="Select Date Range"
              className={classNames(
                { "p-invalid": errorLog && !dateRange },
                "mt-2",
              )}
            />
            {errorLog && (
              <span>
                {dateRange === undefined && (
                  <div style={{ color: "red" }}>Select Date Range!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-6 md:col-2 mb-0">
            <MultiSelect
              filter
              value={teamMember}
              options={employeeList}
              onChange={(e) => setTeamMember(e.value)}
              optionLabel="name"
              placeholder="Select Employee"
              maxSelectedLabels={1}
              showClear
              style={{ width: "158px" }}
              className={classNames(
                { "p-invalid": errorLog && !teamMember },
                "mt-2",
              )}
            />
            {errorLog && (
              <span>
                {teamMember === null && (
                  <div style={{ color: "red" }}>Select Employee!</div>
                )}
              </span>
            )}
          </div>

          <div className="field col-6 md:col-3 mb-0 mt-2">
            {/* <Button label="Filter" className="p-button-rounded" icon="pi pi-search" type="button" onClick={() => filterDayWiseTimesheet({ "pageNum": 0, "pageSize": size })} /> */}
            <Button
              label="Filter"
              className="p-button-rounded"
              icon="pi pi-search"
              type="button"
              onClick={filterDayWiseTimesheet}
            />
            <Button
              label="Export"
              className="p-button-rounded p-button-info ml-1"
              icon="pi pi-download"
              type="button"
              onClick={exportExcel}
              disabled={isExportDisabled}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  const billingTypeTemplate = (item) => {
    return item?.billingType === "Chargeable" ? (
      <span style={{ color: "green" }}>Chargeable</span>
    ) : (
      <span style={{ color: "red" }}>Non-Chargeable</span>
    );
  };

  const approvalStatusTemplate = (item) => {
    return item?.status === "REVIEW" ? (
      <span style={{ color: "orange" }}>REVIEW</span>
    ) : item?.status === "APPROVED" ? (
      <span style={{ color: "green" }}>APPROVED</span>
    ) : (
      <span style={{ color: "red" }}>LOCKED</span>
    );
  };

  const hoursRoundOff = (item) => {
    return item.hours?.toFixed(2);
  };

  // const onBasicPageChange = (e) => {
  //   setBasicFirst(e.first);
  //   setSize(e.rows);
  //   setPage(page + e.page);
  //   setBasicRows(e.rows);
  //   let param = {
  //     pageNum: e.page,
  //     pageSize: e.rows,
  //   }
  //   filterDayWiseTimesheet(param);
  // };

  // const footerCompliance = (
  //   <React.Fragment>
  //     <Paginator
  //       first={basicFirst}
  //       rows={basicRows}
  //       totalRecords={totalRecords}
  //       onPageChange={onBasicPageChange}
  //       rowsPerPageOptions={rowsPerPageOptions}
  //       paginatortemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
  //       currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
  //     ></Paginator>
  //   </React.Fragment>
  // );

  return (
    <div>
      <Card className="">
        <Toolbar className="mb-4" left={DayWiseFilter}></Toolbar>
        <DataTable
          paginator
          value={dayWiseData}
          responsiveLayout="scroll"
          scrollable
          stripedRows
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
        >
          {/* <DataTable dataKey="id" responsiveLayout="scroll" resizableColumns columnResizeMode="fit" scrollable="horizontal" stripedRows value={dayWiseData} footer={footerCompliance}> */}
          <Column
            field="buProject"
            header="BU"
            sortable
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            field="ecn"
            header="ECN"
            sortable
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            field="name"
            header="Employee Name"
            className="capitalize"
            sortable
            style={{ minWidth: "13rem" }}
          ></Column>
          <Column
            field="pmName"
            header="Timesheet Approver"
            sortable
            style={{ minWidth: "14rem" }}
          ></Column>
          <Column
            field="timesheetId"
            header="Timesheet ID"
            sortable
            style={{ minWidth: "13rem" }}
          ></Column>
          <Column
            field="activity"
            header="Activity"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            field="category"
            header="Category"
            sortable
            style={{ minWidth: "8rem" }}
          ></Column>
          <Column
            field="description"
            header="Description"
            sortable
            style={{ minWidth: "13rem" }}
          ></Column>
          <Column
            field="taskID"
            header="Task ID"
            sortable
            style={{ minWidth: "8rem" }}
          ></Column>
          <Column
            field="timesheetDate"
            header="Timesheet Date"
            sortable
            style={{ minWidth: "13rem" }}
          ></Column>
          <Column
            field="projectID"
            header="Project ID"
            sortable
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            field="projectName"
            header="Project Name"
            sortable
            style={{ minWidth: "15rem" }}
          ></Column>
          <Column
            field=""
            header="Hours"
            body={hoursRoundOff}
            sortable
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            field=""
            header="Billing Type"
            body={billingTypeTemplate}
            style={{ minWidth: "10rem" }}
          ></Column>
          <Column
            field="month"
            header="Month"
            sortable
            style={{ minWidth: "6rem" }}
          ></Column>
          <Column
            field="year"
            header="Year"
            sortable
            style={{ minWidth: "5rem" }}
          ></Column>
          <Column
            field=""
            header="Timesheet Approval Status"
            body={approvalStatusTemplate}
            style={{ minWidth: "16rem" }}
          ></Column>
        </DataTable>
      </Card>
    </div>
  );
}
